import React from 'react'
import { Step, StepLabel, Stepper, useMediaQuery } from '@material-ui/core'

import useIncidentManegement from 'hooks/useIncidentManegement'

import useStyles from './styles'
import theme from 'theme'

const IncidentStepper = ({ type }) => {
  const { activeStep, handleStep, isCompleted, incident, isShow } =
    useIncidentManegement()
  const classes = useStyles()
  const matches = useMediaQuery(theme.breakpoints.up('lg'))

  const steps = () => {
    const defaultSteps = [
      'Detecção',
      'Investigação',
      'Alto Risco',
      'Avaliação',
      'Lições Aprendidas',
    ]

    if ((type === 'edit' || isShow) && incident?.confirmed) {
      defaultSteps.splice(
        4,
        0,
        'Formulário ANPD',
        'Tratamento',
        'Relatório',
        'Comunicação',
      )
    }

    return defaultSteps
  }

  return (
    <Stepper
      activeStep={activeStep}
      orientation={matches ? 'horizontal' : 'vertical'}
    >
      {steps().map((step, index) => (
        <Step
          key={step}
          onClick={() => handleStep(index)}
          completed={isCompleted(index)}
          className={classes.stepper}
        >
          <StepLabel>{step}</StepLabel>
        </Step>
      ))}
    </Stepper>
  )
}

export default IncidentStepper
